export enum EmailDirection {
  INBOUND = "INBOUND",
  OUTBOUND = "OUTBOUND",
}

/** Where a contact sits relative to the clinic: staff, the outside world, or the shared clinic mailbox. */
export enum EmailContactType {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
  SYSTEM = "SYSTEM",
}

/** A participant's role on a message. */
export enum EmailParticipantRole {
  FROM = "FROM",
  TO = "TO",
  CC = "CC",
  BCC = "BCC",
}

/**
 * How the display name on staff-composed inbox email ("From") is chosen.
 * PROVIDER = the sending provider's name; CLINIC = the clinic (tenant) name.
 */
export enum EmailSenderNameMode {
  PROVIDER = "PROVIDER",
  CLINIC = "CLINIC",
}
